import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";

function EditOrder() {
  const [recordData, setRecordData] = useState({});
  const [error, setError] = useState(false);
  const token = localStorage.getItem("token");
  const history = useHistory();
  const { userData } = useContext(UserDataContext);
  const { id } = useParams();
  const [file, setFile] = useState(null);

  async function register(e) {
    e.preventDefault();

    try {
      let payload = recordData;

      if (recordData.reklamation_status === "erledigt") {
        payload.status = "erledigt";
      }
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/order/edit/${id}`,
        payload,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      history.goBack();
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  async function reklamieren(e) {
    e.preventDefault();

    try {
      console.log(recordData);
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/order/edit/${id}`,
        {
          ...recordData,
          reklamation_status: "offen",
          reklamation_date: new Date(),
          reklamiert_von: userData.name,
          status: "reklamiert",
        },
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      history.go(0);
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  async function deleteOrderCall() {
    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/order/delete/${recordData._id}`,
      { userData },
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    history.go(0);
  }

  async function getData() {
    let recordData = await axios.get(
      `${process.env.REACT_APP_BACKEND}/services/orders/${id}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    console.log(recordData.data);
    setRecordData(recordData.data);
  }

  async function uploadFile(e) {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("file", document.getElementById("filePicker").files[0]);
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/settings/upload-file/order/${id}`,
        formData,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      history.go(0);
    } catch (err) {
      setError(true);
      console.error(err);
    }
  }

  useEffect(() => {
    getData();
  }, [userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Bestellung bearbeiten
          </h3>
        </div>
      </div>
      <div className="bg-white overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div class="grid grid-cols-4 gap-4">
              <div class="col-span-3">
                <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                    Bestellung
                  </div>
                  <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                    <form onSubmit={register}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Pos. Nr.
                              </label>
                              <input
                                disabled
                                type="text"
                                value={
                                  recordData.service &&
                                  recordData.service.pos_nr
                                }
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Pos. Name
                              </label>
                              <input
                                disabled
                                type="text"
                                value={
                                  recordData.service &&
                                  recordData.service.pos_name
                                }
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Status
                              </label>
                              <select
                                required="true"
                                onChange={(e) =>
                                  setRecordData({
                                    ...recordData,
                                    status: e.target.value,
                                  })
                                }
                                va
                                value={recordData.status}
                                className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value={recordData.status}>
                                  {recordData.status}
                                </option>
                                <option value="offen">offen</option>
                              </select>
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Bestelldatum
                              </label>
                              <input
                                type="date"
                                required="true"
                                onChange={(e) =>
                                  setRecordData({
                                    ...recordData,
                                    orderDate: e.target.value,
                                  })
                                }
                                value={recordData.orderDate}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Erledigt am
                              </label>
                              <input
                                type="date"
                                onChange={(e) =>
                                  setRecordData({
                                    ...recordData,
                                    orderDoneDate: e.target.value,
                                  })
                                }
                                value={recordData.orderDoneDate}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Preisreferenz
                              </label>
                              <select
                                required="true"
                                onChange={(e) =>
                                  setRecordData({
                                    ...recordData,
                                    preis: e.target.value,
                                  })
                                }
                                va
                                value={recordData.preis}
                                className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="preis_1">Mo. - Sa.</option>
                                <option value="preis_2">So.</option>
                                <option value="preis_3">Feiertag</option>
                                <option value="preis_4">Nachtschicht</option>
                              </select>
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Erstellt von
                              </label>
                              <input
                                disabled
                                type="text"
                                value={recordData.createdBy}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Abgenommen von
                              </label>
                              <input
                                disabled
                                type="text"
                                value={recordData.approvedBy}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Storniert von
                              </label>
                              <input
                                disabled
                                type="text"
                                value={recordData.canceledBy}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                            <div className="col-span-3">
                              <label className="block text-sm font-medium text-gray-700">
                                Kommentar
                              </label>
                              <textarea
                                rows="3"
                                type="textarea"
                                onChange={(e) =>
                                  setRecordData({
                                    ...recordData,
                                    comment: e.target.value,
                                  })
                                }
                                value={recordData.comment}
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Speichern
                          </button>
                          {error && (
                            <div
                              className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                              role="alert"
                            >
                              <svg
                                className="fill-current w-6 h-6 mr-3"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                              </svg>
                              <p>
                                Fehler beim speichern. Bitte wenden Sie sich an
                                einen Administrator.
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                {recordData.reklamation_status && (
                  <div className="border-b my-5 border-gray-200 shadow overflow-hidden sm:rounded-lg">
                    <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                      Reklamation
                    </div>
                    <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                      <form onSubmit={register}>
                        <div className="shadow overflow-hidden sm:rounded-md">
                          <div className="px-4 py-5 bg-white sm:p-6">
                            <div className="grid grid-cols-6 gap-6">
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  Status Reklamation
                                </label>
                                <select
                                  required="true"
                                  disabled={
                                    recordData.reklamation_status === "erledigt"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    setRecordData({
                                      ...recordData,
                                      reklamation_status: e.target.value,
                                    })
                                  }
                                  va
                                  value={recordData.reklamation_status}
                                  className="mt-1 pl-3 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                >
                                  <option value={recordData.reklamation_status}>
                                    {recordData.reklamation_status}
                                  </option>
                                  <option value="offen">offen</option>
                                  <option value="erledigt">erledigt</option>
                                </select>
                              </div>
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  Reklamiert am
                                </label>
                                <input
                                  disabled={
                                    recordData.reklamation_status === "erledigt"
                                      ? true
                                      : false
                                  }
                                  type="date"
                                  required="true"
                                  onChange={(e) =>
                                    setRecordData({
                                      ...recordData,
                                      reklamation_date: e.target.value,
                                    })
                                  }
                                  value={recordData.reklamation_date}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>

                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  Reklamiert von
                                </label>
                                <input
                                  disabled
                                  type="text"
                                  value={recordData.reklamiert_von}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                              <div className="col-span-3">
                                <label className="block text-sm font-medium text-gray-700">
                                  Kommentar
                                </label>
                                <textarea
                                  rows="3"
                                  disabled={
                                    recordData.reklamation_status === "erledigt"
                                      ? true
                                      : false
                                  }
                                  type="textarea"
                                  onChange={(e) =>
                                    setRecordData({
                                      ...recordData,
                                      reklamation_comment: e.target.value,
                                    })
                                  }
                                  value={recordData.reklamation_comment}
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <button
                              type="submit"
                              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                              Speichern
                            </button>
                            {error && (
                              <div
                                className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                                role="alert"
                              >
                                <svg
                                  className="fill-current w-6 h-6 mr-3"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                                </svg>
                                <p>
                                  Fehler beim speichern. Bitte wenden Sie sich
                                  an einen Administrator.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
              <div class="col-span-1">
                <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className=" px-4 py-3 bg-gray-50 sm:px-6">Optionen</div>
                  {recordData.active && (
                    <button
                      type="submit"
                      onClick={deleteOrderCall}
                      className="mx-2 my-5 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
                    >
                      Bestellung stornieren
                    </button>
                  )}
                  {recordData.status === "erledigt" && (
                    <button
                      type="submit"
                      onClick={(e) => {
                        reklamieren(e);
                      }}
                      className="mx-2 my-5 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md border-red-600 hover:bg-red-700"
                    >
                      Bestellung reklamieren
                    </button>
                  )}
                </div>
                <div className="mt-5 border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
                  <div className=" px-4 py-3 bg-gray-50 sm:px-6">
                    Dateianhänge
                  </div>
                  <ul className="mx-5">
                    {recordData &&
                      recordData.attachments &&
                      recordData.attachments.map((url) => (
                        <a href={url} target="_blank">
                          <li>{url.split("/")[5]} </li>
                        </a>
                      ))}
                  </ul>
                  <hr className="my-3"></hr>
                  <form
                    onSubmit={uploadFile}
                    enctype="multipart/form-data"
                    className="mx-5"
                  >
                    <label
                      for="cover-photo"
                      class="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Anhang speichern
                    </label>
                    <div class="mt-2">
                      <input
                        required
                        type="file"
                        name="upload"
                        id="filePicker"
                        accept=".pdf, image/*"
                        onChange={(e) => setFile(e.target.files)}
                      />
                    </div>
                    <button
                      type="submit"
                      className="my-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Hochladen
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditOrder;
